import React from 'react';

import "./StatBox.css";
import Tooltip from '@mui/material/Tooltip';

interface StatBoxProps {
    colWidth: number
    data: number
    percent: boolean
    title: string
    hoverText?: string
}

export default function StatBox({colWidth, data, percent, title, hoverText = ""}: StatBoxProps) {
    return (
        <div className={`col-${colWidth}`}>
        <div className="stat-box-container">
        <Tooltip title={hoverText} aria-label="expiration-date">
            <div className="title">
                {title}
            </div>
            </Tooltip>
            <div className="data">
                {data.toFixed(0)}
                {percent ? '%' : ''}
            </div>
        </div>
        </div>
    )
}